import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Logo } from "@/components/landing/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult() {
  const location = useLocation();
  const isSuccess = location.pathname.includes("success");
  const sessionId = new URLSearchParams(location.search).get("session_id");
  const [state, setState] = useState(isSuccess ? "polling" : "cancel");

  useEffect(() => {
    if (!isSuccess) return;
    if (!sessionId) {
      setState("failed");
      return;
    }
    let tries = 0;
    const iv = setInterval(async () => {
      tries += 1;
      try {
        const r = await axios.get(`${API}/billing/status/${sessionId}`);
        if (["paid", "no_payment_required"].includes(r.data.payment_status) || r.data.status === "completed") {
          setState("ok");
          clearInterval(iv);
          return;
        }
        if (["expired", "failed"].includes(r.data.payment_status)) {
          setState("failed");
          clearInterval(iv);
          return;
        }
      } catch {}
      if (tries >= 8) {
        setState("timeout");
        clearInterval(iv);
      }
    }, 2000);
    return () => clearInterval(iv);
  }, [isSuccess, sessionId]);

  const content = {
    polling: { icon: <Loader2 size={44} className="animate-spin" style={{ color: "var(--camel)" }} />, title: "Einen Moment …", text: "Wir bestätigen dein Abo gerade bei Stripe." },
    ok: { icon: <CheckCircle2 size={44} style={{ color: "var(--camel)" }} />, title: "Willkommen bei Mira! ✦", text: "Dein Abo ist eingerichtet – die ersten 30 Tage sind kostenlos. Du erhältst alle Rechnungen automatisch per E-Mail. Wir melden uns für das Onboarding." },
    timeout: { icon: <Loader2 size={44} style={{ color: "var(--gold)" }} />, title: "Bestätigung ausstehend", text: "Die Zahlung wird noch verarbeitet. Du erhältst eine E-Mail, sobald alles bestätigt ist." },
    failed: { icon: <XCircle size={44} style={{ color: "var(--rose)" }} />, title: "Das hat nicht geklappt", text: "Die Sitzung ist abgelaufen oder fehlgeschlagen. Starte den Vorgang bitte erneut oder melde dich bei uns." },
    cancel: { icon: <XCircle size={44} style={{ color: "var(--muted-warm)" }} />, title: "Vorgang abgebrochen", text: "Kein Problem – es wurde nichts gebucht. Du kannst jederzeit neu starten oder uns kontaktieren." },
  }[state];

  return (
    <main className="flex min-h-screen items-center justify-center px-5" style={{ background: "var(--surface)" }} data-testid={`payment-${isSuccess ? "success" : "cancel"}-page`}>
      <div className="w-full max-w-md rounded-3xl border p-10 text-center" style={{ borderColor: "var(--line)", background: "var(--surface-secondary)" }}>
        <div className="flex justify-center"><Logo size={40} /></div>
        <div className="mt-6 flex justify-center">{content.icon}</div>
        <h1 className="mt-5 font-serif-display text-3xl font-semibold" data-testid="payment-result-title">{content.title}</h1>
        <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--muted-warm)" }}>{content.text}</p>
        <Link to="/" className="pill-btn mt-7 inline-block rounded-full px-7 py-3 text-sm font-medium text-white" style={{ background: "var(--camel)" }} data-testid="payment-result-home-btn">
          Zur Startseite
        </Link>
      </div>
    </main>
  );
}
